import httpRaspberrySoul from 'src/infrastructure/httpRaspberrySoul'
import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import {
  GenericApiErrors,
  LocalPrinterData,
  PrinterData,
  SaveLocalPrinterSettingsPayload,
  ValidatedPrinterBadge,
} from './PrintersManagementTypes'
import axios from 'axios'

const getLocalPrinter = async () => {
  try {
    const result = await httpRaspberrySoul.get('/health')

    return parseGoodResponse<LocalPrinterData>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const getActivePrinters = async (fulfillmentCenterId: number) => {
  try {
    const result = await http.get(`/v2/devices/printers/${fulfillmentCenterId}`)

    return parseGoodResponse<PrinterData[]>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const saveLocalPrinterSettings = async (payload: SaveLocalPrinterSettingsPayload) => {
  try {
    const {
      fulfillmentCenterId, kdabraUrl, deviceName, printerServer,
    } = payload

    const body = {
      fulfillment_center_id: fulfillmentCenterId,
      kdabra_url: kdabraUrl,
      device_name: deviceName,
      printer_server: printerServer,
    }

    const result = await httpRaspberrySoul.post('/config', body)

    return parseGoodResponse(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const validatePrinterBadge = async (badge: string) => {
  try {
    const result = await http.get('/v2/devices/printers/validate-badge', {
      headers: { 'user-barcode': badge },
    })

    return parseGoodResponse<ValidatedPrinterBadge>(result.data.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const checkRemotePrinterHealth = async (ip: string) => {
  try {
    const remoteHttp = axios.create({
      baseURL: `http://${ip}:2525`,
    })

    const result = await remoteHttp.get('/health')

    return parseGoodResponse<LocalPrinterData>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export default {
  getLocalPrinter,
  getActivePrinters,
  saveLocalPrinterSettings,
  validatePrinterBadge,
  checkRemotePrinterHealth,
}
